module.exports = __webpack_public_path__ + "img/m-title.365adb3a.png";